import { oauthService } from '@afterpaytouch/portal-api/consumer/oauth'

export const { useConfirmAccessQuery, useAuthorizeMutation, useGetPermissionsQuery, useDeletePermissionMutation } = oauthService
